import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { FulfillmentGroupStatus } from "@redotech/redo-fulfillment-group-common/fulfillment-group-status";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { formatDateString } from "../../utils/outbound-labels-utils";

const catalogEntry = fgColumnEntries["shipped-date"];

export const ShippedDateColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => {
    const shipDate = row.fulfillmentInfo?.shipDate;
    const isShipped = row.status === FulfillmentGroupStatus.Closed && shipDate;

    return (
      <RedoTableTextCell
        subtext={
          isShipped
            ? shipDate
                ?.toLocaleTimeString(undefined, {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                })
                .toLowerCase()
            : undefined
        }
        text={isShipped ? formatDateString(shipDate?.toISOString()) : ""}
      />
    );
  },
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
